import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  iconForEventType,
  labelForEventType,
} from "@models/enums/notification-event-type.enum";
import { Notification } from "@models/notification";
import { RelativeTimePipe } from "../../pipes/relative-time.pipe";

@Component({
  selector: "app-notification-item",
  standalone: true,
  imports: [CommonModule, RelativeTimePipe],
  templateUrl: "./notification-item.component.html",
  styleUrl: "./notification-item.component.scss",
})
export class NotificationItemComponent {
  @Input({ required: true }) notification!: Notification;
  @Output() read = new EventEmitter<Notification>();
  @Output() openAction = new EventEmitter<Notification>();

  get icon(): string {
    return iconForEventType(this.notification.event_type);
  }

  get categoryLabel(): string {
    return labelForEventType(this.notification.event_type);
  }

  get isUnread(): boolean {
    return !this.notification.read_at;
  }

  handleClick(): void {
    if (this.isUnread) {
      this.read.emit(this.notification);
    }
    this.openAction.emit(this.notification);
  }
}
